export default __webpack_public_path__ + "static/media/ds-ordenacao-js.6dfe56ac.png";